import type { SelectedReason } from '../interface/reasons';
import type {
  TransferDestination,
  TransferPayload
} from '../interface/transfer';

export interface TransferFormValues {
  readonly destination?: TransferDestination;
  readonly reasons: readonly SelectedReason[];
  readonly note: string;
  readonly caseContext: string;
}

export type TransferValidationError = 'recipient-required' | 'reason-required';

type Result =
  | { ok: true; payload: TransferPayload }
  | { ok: false; errors: TransferValidationError[] };

export function buildTransferPayload(values: TransferFormValues): Result {
  const errors: TransferValidationError[] = [];
  if (!values.destination) errors.push('recipient-required');

  const seen = new Set<string>();
  const reasons = values.reasons.filter((r) =>
    seen.has(r.key) ? false : (seen.add(r.key), true)
  );
  if (reasons.length === 0) errors.push('reason-required');

  if (errors.length > 0) return { ok: false, errors };

  const note = values.note.trim();
  const caseContext = values.caseContext.trim();
  const payload: TransferPayload = {
    destination: values.destination as TransferDestination,
    reasons,
    ...(note.length > 0 ? { note } : {}),
    ...(caseContext.length > 0 ? { caseContext } : {})
  };
  return { ok: true, payload };
}
